import { render, staticRenderFns } from "./OrdersOnSale.vue?vue&type=template&id=61c164e2&"
import script from "./OrdersOnSale.vue?vue&type=script&lang=js&"
export * from "./OrdersOnSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports